module.exports = __webpack_public_path__ + "static/img/01037D_1_R_201990227_LC.699ff7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01037D_1_R_201990227_LC.png
// module id = UTaT
// module chunks = 0